import React from 'react';
import Header from './Header/Header';
import Projects from '../Projects/Projects';
import About from '../About/About';
import Services from '../Services/Services';
import transition from '../../transition';
import Contact from '../../components/Contact/Contact';
import ScrollingSection from '../../components/ScrollingSection/ScrollingSection';
// import PaperCollage from '../../components/PaperCollage/PaperCollage';

const Home = () => {
  return (
    <div>
      <Header />
      <About />
      <Projects />
      <ScrollingSection />
      <Services />
      {/* <PaperCollage /> temporarily hidden */}
      <Contact />
    </div>
  );
};

export default transition(Home);
